export default __webpack_public_path__ + "static/media/vixa.c6375a37.png";